import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentUser: any;
  userFlag: boolean = false
  date: number = new Date().getFullYear();
  darkTheme: boolean;
  deletedImagePath: string;
  isInIframe: boolean;
  activePage:boolean = false;

  constructor(private authService: AuthService,
    private localStorageService: DataService,
    private themeService: ThemeService,
    private router: Router
    ) {
      this.isInIframe = this.themeService.isInIframe();

    this.localStorageService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;
    });
  }

  ngOnInit(): void {
    this.authService.getCurrentUser();
    this.getUser();
    const currentUrl = this.router.url;
    if (currentUrl === '/howitworks') {
      this.activePage = true;
    }
    this.router.events.subscribe((event: any) => {      
      if (event instanceof NavigationEnd) {
        if (event?.url === '/howitworks') {
          this.activePage = true;
        } else {
          this.activePage = false;
        }
      }
    });
  }

  getUser() {
    const castUser = this.authService.castCurrentUser.subscribe(async (res: any) => {
      this.currentUser = await res;
      //(this.currentUser, "getCurrentUser")
      if (this.currentUser) {
        this.userFlag = true;
      } else {
        this.userFlag = false;
      }
      castUser.unsubscribe();
    });
  }

  openNewTab(url: string) {
    localStorage.setItem('sessionStorageCopy', JSON.stringify(sessionStorage));
    window.open(url, '_blank');
  }
}
